import { render } from "./ChevronDownIcon.vue?vue&type=template&id=d5ee4c1c"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__